import { render, staticRenderFns } from "./ErnaehrungBeiUebergewicht.vue?vue&type=template&id=7b6a4269&"
import script from "./ErnaehrungBeiUebergewicht.vue?vue&type=script&lang=js&"
export * from "./ErnaehrungBeiUebergewicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports